<template>
  <full-container>
    <template slot="header">
      <div class="toolbar">
        <el-form inline size="small">
          <el-form-item>
            <el-date-picker style="width: 220px" type="daterange" v-model="queryParams.dateSpan" start-placeholder="开始日期" end-placeholder="结束日期" @change="onSearch()" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="queryParams.keyWord" clearable placeholder="关键字查询">
              <template slot="append">
                <el-button icon="el-icon-search" @click="onSearch()" />
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <!--表格-->
    <el-table v-loading="loading" :data="datalist.Items" height="100%">
      <el-table-column label="类别" min-width="80" align="center">
        <template slot-scope="{ row }">
          {{ $utils.meta.format('audit', row.Mode) }}
        </template>
      </el-table-column>
      <el-table-column label="送审时间" width="140">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row.CreateTime, '{y}-{m}-{d} {h}:{i}') }}
        </template>
      </el-table-column>
      <el-table-column prop="Submitter.Name" label="请示人" min-width="100" />
      <el-table-column prop="Request" label="请示内容（点击看详情）" min-width="200">
        <template slot-scope="{ row }">
          <el-link @click.native="onReview(row)" type="primary" class="text-space">
            {{ row.Request }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="Reviewer.Name" label="审核人" min-width="100" />
      <el-table-column prop="Response" label="审核意见" min-width="200" show-overflow-tooltip />
      <el-table-column label="审核时间" width="140">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row.ModifyTime, '{y}-{m}-{d} {h}:{i}') }}
        </template>
      </el-table-column>
      <el-table-column label="状态/操作" width="100">
        <template slot-scope="{ row }">
          <el-link @click.native="onApprove(row)" :type="row.State == -1 ? 'danger' : 'primary'">
            {{ row.StateText }}
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination slot="footer" background :page-size="queryParams.size" :total="datalist.TotalCount" @current-change="onSearch" />
  </full-container>
</template>


<script>
export default {
  data () {
    return {
      loading: false,
      datalist: {},
      queryParams: {
        index: 1,
        size: 20,
      },
      stateOptions: [{
        text: '未通过',
        value: -1
      }, {
        text: '待审核',
        value: 0
      }, {
        text: '已通过',
        value: 1
      }]
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    // 查询参数
    onSearch (val = 1) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.organize.audit.list(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    //判断
    onReview (row) {
      switch (row.Mode) {
        case "Mall-Order": {
          this.$router.push({ path: `/mall/order/detail/${row.Target}` })
          break
        }
        default: {
          this.onApprove(row)
        }
      }
    },
    //审核
    onApprove (row) {
      this.$prompt(null, '审核', {
        confirmButtonText: '同意',
        cancelButtonText: '拒绝',
        inputType: 'textarea',
        inputPlaceholder: '请填写审核意见...',
        distinguishCancelAndClose: true,
        callback: (action, { inputValue }) => {
          //判定
          let state = null
          switch (action) {
            case "confirm": {
              state = true
              break
            }
            case "cancel": {
              state = false
              break
            }
          }
          //提交
          if (state !== null) {
            this.$apis.organize.audit.complete({
              Id: row.Id,
              State: state,
              Response: inputValue
            }).then(() => {
              this.loadData()
            }).catch((e) => {
              this.$message.error(e || "系统错误")
            })
          }
        }
      })
    }
  }
}
</script>
